import { render, staticRenderFns } from "./product-text-image.vue?vue&type=template&id=306e59a3&"
import script from "./product-text-image.vue?vue&type=script&lang=js&"
export * from "./product-text-image.vue?vue&type=script&lang=js&"
import style0 from "./product-text-image.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports